import { Component, Input, Output, EventEmitter, ElementRef, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pill-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pill-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pill-dropdown.component.scss'],
})
export class PillDropdownComponent {
  private elementRef = inject(ElementRef);

  @Input() options: string[] = [];
  @Input() selectedOption = '';
  @Input() dropdownId = '';
  @Input() type = '';
  @Input() positionMenu: 'left' | 'right' = 'right';
  @Input() isDisabled = false;

  @Output() optionSelected = new EventEmitter<{ id: string; value: string }>();
  @Output() cleared = new EventEmitter<{ id: string }>();

  isOpen = false;

  /**
   * Toggle the dropdown visibility
   */
  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  /**
   * Select an option from the dropdown
   * @param option The selected option
   */
  selectOption(option: string): void {
    this.optionSelected.emit({ id: this.dropdownId, value: option });
    this.isOpen = false;
  }

  /**
   * Close the dropdown when clicking outside
   */
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  /** Clear current selection  */
  clearFilters(event?: MouseEvent): void {
    event?.stopPropagation();

    let newValue = '';

    if (this.dropdownId === 'status') {
      newValue = 'Status';
    }
    if (this.dropdownId === 'sortBy' || this.dropdownId === 'sort') {
      newValue = 'Sort By';
    }
    if (this.dropdownId === 'action') {
      newValue = 'Action Required';
    }
    if (this.dropdownId === 'role') {
      newValue = 'Role';
    }
    if (this.dropdownId === 'activity') {
      newValue = 'Activity Type';
    }
    if (this.dropdownId === 'time') {
      newValue = 'All Time';
    }
    if (this.dropdownId === 'currency') {
      newValue = 'Currency';
    }
    if (this.dropdownId === 'merchant') {
      newValue = 'Merchants';
    }

    this.selectedOption = newValue;
    this.optionSelected.emit({ id: this.dropdownId, value: newValue });
    this.cleared.emit({ id: this.dropdownId });
    this.isOpen = false;
  }

  get filtersApplied(): boolean {
    const excluded = ['Status', 'Action Required', 'Sort By', 'Role', 'All Time', 'Activity Type', 'Currency','Merchants'];
    return !!this.selectedOption && this.selectedOption.trim().length > 0 && !excluded.includes(this.selectedOption);
  }
}
